import React from 'react';
import { Box, Typography } from '@mui/material';

import { ButtonUI, FormLabelUI, InputUI } from '../../Interface';

const TargetDocTab = ({ reference, onReferenceChange, note, onNoteChange, onSave }) => {
  return (
    <Box sx={{ px: 1, pb: 1, pt: 3 }}>
      <Box
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          p: 1.5,
          bgcolor: 'grey.100',
        }}
      >
        <Box sx={{ mt: 1, display: 'grid', gridTemplateColumns: 'repeat(1, minmax(0, 1fr))', gap: 1.5 }}>
          <InputUI
            fullWidth
            size="small"
            sx={{ '& .MuiInputBase-root': { bgcolor: 'common.white' } }}
            label={<FormLabelUI text="Hivatkozás" />}
            value={reference}
            onChange={(e) => onReferenceChange(e.target.value)}
          />

          <InputUI
            fullWidth
            size="small"
            sx={{ '& .MuiInputBase-root': { bgcolor: 'common.white' } }}
            multiline
            minRows={3}
            label={<FormLabelUI text="Megjegyzés" />}
            value={note}
            onChange={(e) => onNoteChange(e.target.value)}
          />

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
            <ButtonUI text="Rögzítés" className="bg-success" onClick={onSave} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TargetDocTab;
